import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGUAGES, translations } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  dir: "ltr",
  languages: LANGUAGES,
  setLang: () => {},
  t: (k) => k,
});

export const useLanguage = () => useContext(LanguageContext);

const getPath = (obj, path) =>
  path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("evo-lang") || "en"; } catch { return "en"; }
  });

  const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const dir = meta.dir;

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    try { localStorage.setItem("evo-lang", lang); } catch {}
  }, [lang, dir]);

  const setLang = useCallback((code) => setLangState(code), []);

  const t = useCallback(
    (key) => {
      const v = getPath(translations[lang] || {}, key);
      if (v !== undefined) return v;
      const fallback = getPath(translations.en, key);
      return fallback !== undefined ? fallback : key;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, dir, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
